import L from "leaflet";

export async function loadCyclewayLayer(options = {}) {
  const {
    url = "/cycleway.json",
    pane = "cycleway",
    color = "#7a1200",
    weight = 1.5,
  } = options;

  const response = await fetch(url);
  const data = await response.json();

  return L.geoJSON(data, {
    style: () => ({
      color,
      weight,
      fillOpacity: 1,
    }),
    pane,
  });
}
